<template>
  <div class="relative">
    <div class="absolute top-0 right-4">
      <feather-icon icon="XIcon" @click="handleClose" />
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="w-full pt-5">
          <p class="fsize15">First Name <span class="clr-red">*</span></p>
          <base-input
            v-model="firstname"
            placeholder="Enter firstname"
            name="First Name"
            class="cust-form-border"
            :rules="{ required: true, alpha_spaces: true }"
          ></base-input>
        </div>
        <div class="w-full pt-5">
          <p class="fsize15">Last Name <span class="clr-red">*</span></p>
          <base-input
            v-model="lastname"
            placeholder="Enter lastname"
            name="Last Name"
            :rules="{ required: true, alpha_spaces: true }"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="w-full pt-3">
          <p class="fsize15">Email <span class="clr-red">*</span></p>
          <base-input
            v-model="email"
            placeholder="Enter email"
            name="email"
            :rules="{ required: true, email: true }"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="w-full pt-3">
          <p class="fsize15">Contact No <span class="clr-red">*</span></p>
          <base-input
            v-model="mobile"
            placeholder="Enter number"
            :rules="{ numeric: true, required: true, regex: '^[0-9]{10}$' }"
            name="contact number"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="w-full pt-3">
          <p class="fsize15">Brand Name <span class="clr-red">*</span></p>
          <base-input
            v-model="brand"
            placeholder="Enter brand name"
            name="brand name"
            :rules="{ required: true, alpha_spaces: true }"
            class="cust-form-border"
          ></base-input>
        </div>
        <div class="pt-5 flex justify-center">
          <button class="bg-primary text-white px-8 py-2 rounded" type="submit">
            Submit
          </button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstname: "",
      lastname: "",
      mobile: "",
      email: "",
      brand: "",
    };
  },
  methods: {
    handleClose() {
      this.$bvModal.hide("IsshowVendor");
    },
    async onSubmit() {
      let payload = {
        firstname: this.firstname.trim(),
        lastname: this.lastname.trim(),
        mobile: this.mobile.trim(),
        email: this.email.trim(),
        brand: this.brand.trim(),
      };
      let loader = this.$loading();

      try {
        let data = await this.$store.dispatch("affiliate/addVendor", payload);
        this.$bvModal.hide("IsshowVendor");
        // console.log(data);
        loader.close();
        if (data.code === 200) {
          this.$store.dispatch("affiliate/getVendorByAdmin");
          await this.$swal.fire({
            text: "Vendor added successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error.response.status == 409) {
          loader.close();
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.$router.push({ name: "login" });
        } else if (error) {
          loader.close();
          this.$swal.fire({
            text: "Something went wrong",
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
  },
};
</script>

<style></style>
